import { useEffect, useState } from 'react';

import { useApi } from '../util/lib';

export const useUnsubscribe = (customerId) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [unsubscribe, setUnsubscribe] = useState(null);
  const api = useApi();
  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const response = await api({
          method: 'get',
          responseType: 'json',
          url: `/customers/${customerId}/unsubscribe`,
        });
        if (!response?.data?.success) {
          throw new Error('Failed to unsubscribe');
        }
        setLoading(false);
        setUnsubscribe(response.data?.unsubscribe || null);
        return response.data;
      } catch (error) {
        setError(error);
        console.error(error);
        setUnsubscribe(null);
      }
    }
    unsubscribe();
  }, [api, customerId, setUnsubscribe]);

  return {
    error,
    loading,
    unsubscribe,
  }
}
